import React, { useState, useEffect, useCallback } from 'react';
import {
  Card, CardContent, Table, TableHead, TableRow, TableCell, TableBody,
  Chip, IconButton, Tooltip, TablePagination, Button, Typography,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import Layout from '../../components/Layout/Layout';
import PageHeader from '../../components/Common/PageHeader';
import SearchFilterBar from '../../components/Common/SearchFilterBar';
import { getUploadHistoryApi, downloadUploadedFileApi, downloadTemplateApi } from '../../api/uploads';

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
  window.URL.revokeObjectURL(url);
}

export default function PublisherUploadHistory() {
  const [history, setHistory] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState('');

  const fetchHistory = useCallback(async () => {
    const res = await getUploadHistoryApi({ page: page + 1, page_size: rowsPerPage, search });
    setHistory(res.data.results || res.data);
    setTotal(res.data.count || res.data.length);
  }, [page, rowsPerPage, search]);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  const handleDownload = async (id, name) => {
    const res = await downloadUploadedFileApi(id);
    downloadBlob(res.data, name);
  };

  const handleTemplate = async () => {
    const res = await downloadTemplateApi();
    downloadBlob(res.data, 'book_upload_template.xlsx');
  };

  return (
    <Layout title="Upload History">
      <PageHeader
        title="Upload History"
        breadcrumbs={[{ label: 'Publisher' }, { label: 'Upload History' }]}
        action={<Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleTemplate}>Download Template</Button>}
      />
      <Card>
        <CardContent>
          <SearchFilterBar searchPlaceholder="Search by file name..." onSearch={setSearch} />
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>File Name</TableCell>
                <TableCell>Uploaded By</TableCell>
                <TableCell>Source</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Success</TableCell>
                <TableCell>Failed</TableCell>
                <TableCell>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((h) => (
                <TableRow key={h.id} hover>
                  <TableCell>{h.original_file_name}</TableCell>
                  <TableCell>{h.uploaded_by_name}</TableCell>
                  <TableCell>
                    <Chip label={h.upload_source} size="small" color={h.upload_source === 'ADMIN' ? 'secondary' : 'primary'} />
                  </TableCell>
                  <TableCell>{new Date(h.upload_date).toLocaleDateString()}</TableCell>
                  <TableCell>{h.total_records}</TableCell>
                  <TableCell><Typography variant="body2" color="success.main">{h.success_count}</Typography></TableCell>
                  <TableCell><Typography variant="body2" color="error.main">{h.failed_count}</Typography></TableCell>
                  <TableCell>
                    <Tooltip title="Download">
                      <IconButton size="small" onClick={() => handleDownload(h.id, h.original_file_name)}>
                        <DownloadIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination component="div" count={total} page={page} rowsPerPage={rowsPerPage}
            onPageChange={(_, p) => setPage(p)}
            onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
            rowsPerPageOptions={[10, 25, 50]} />
        </CardContent>
      </Card>
    </Layout>
  );
}
